var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJackpotStarBronzeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 108,
    viewBox: "0 0 112 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6988 9.85691C49.9258 1.34067 62.0737 1.34066 66.3007 9.8569L72.7121 22.7742C75.1254 27.6363 79.7756 31.0004 85.1487 31.7712L99.3438 33.8076C108.812 35.1658 112.58 46.8153 105.701 53.4613L95.5585 63.2616C91.6249 67.0622 89.8304 72.5652 90.7674 77.954L93.2038 91.9669C94.8364 101.357 84.9942 108.543 76.5474 104.129L63.6419 97.3847C58.8543 94.8828 53.1452 94.8828 48.3577 97.3847L35.4521 104.129C27.0053 108.543 17.1632 101.357 18.7958 91.9669L21.2322 77.954C22.1691 72.5652 20.3747 67.0622 16.4411 63.2616L6.29805 53.4613C-0.580425 46.8153 3.18804 35.1658 12.6558 33.8076L26.8509 31.7712C32.2239 31.0004 36.8741 27.6363 39.2874 22.7742L45.6988 9.85691Z",
    fill: "url(#paint0_linear_971_8391)",
    stroke: "url(#paint1_linear_971_8391)",
    strokeWidth: 5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_971_8391",
    x1: 47.0268,
    y1: 14.0861,
    x2: 83.7134,
    y2: 95.0681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD9268"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102083,
    stopColor: "#F2B694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#B67847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289583,
    stopColor: "#7C4B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471875,
    stopColor: "#EAAE8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.680208,
    stopColor: "#80522E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841667,
    stopColor: "#A77B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#784625"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_971_8391",
    x1: 44.8377,
    y1: 6.08796,
    x2: 82.993,
    y2: 108.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79553F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8BCA7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJackpotStarBronzeIcon);
export default __webpack_public_path__ + "static/media/jackpot_star_bronze_icon.d10a52d96368707e7cc40e282b5a31c1.svg";
export { ForwardRef as ReactComponent };